import { writable } from 'svelte/store';

let state = {
    balance: 0,
    email: '',
    full_name: '',
    contacts: [],
    calls: {},
    voice_messages: {},
    receivers: []
};

let session = () => {
    const { subscribe, set, update } = writable(state);

    return {
        subscribe,
        setBalance: (balance) => {
            return update((store) => ({
                ...store,
                balance: balance,
            }));
        },
        set: (data) => {
            return update((store) => ({
                ...store,
                balance: data.balance,
                email: data.email,
                full_name: data.full_name,
            }));
        },
        setProfile: (data) => {
            return update((store) => ({
                ...store,
                email: data.email,
                full_name: data.full_name,
            }));
        },
        setContacts: (data) => {
            return update((store) => ({
                ...store,
                contacts: data,
            }));
        },
        setCalls: (data) => {
            return update((store) => ({
                ...store,
                calls: data,
            }));
        },
        setNextPaginatedCalls: (data) => {
            return update((store) => ({
                ...store,
                calls: {
                    ...data,
                    results: [...store.calls.results, ...data.results],
                },
            }));
        },
        setVoiceMessages: (data) => {
            return update((store) => ({
                ...store,
                voice_messages: data,
            }));
        },
        setNextPaginatedVoiceMessages: (data) => {
            return update((store) => ({
                ...store,
                voice_messages: {
                    ...data,
                    results: [...store.voice_messages.results, ...data.results],
                },
            }));
        },
        setReceivers: (data) => {
            return update((store) => ({
                ...store,
                receivers: data,
            }));
        },
        logout: () => {
            return update((store) => ({
                state,
            }));
        },
    };
};

export default session();
